export const ActionTypes = {
  LOADING: "DELETE_OPTION_LOADING",
  ERROR: "DELETE_OPTION_ERROR",
  SUCCESS: "DELETE_OPTION_SUCCESS",
};
